import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Animated } from "react-animated-css";
import { isEmpty } from "lodash";
import {
  commonApiCall,
  UNDERWRITING_DETAILS,
  getJwt,
} from "../../../redux/actions/index";
import {
  setProcessStep,
  getProcessStep,
  UnderWritingRoutes,
  showErrorToast,
  segmentTracking,
} from "../../../utils/index";
import {
  API_URL_UNDERWRITING,
  CONSUMER_PORTAL_URL,
} from "../../../config/configs";

const SmokingHabit = ({ commonApiCall, underwriting, t, ...props }) => {
  const { applicationId, applicationType, goalType, policyType, smoker } =
    underwriting;
  const [formData, setFormData] = useState({
    applicationId: applicationId,
    applicationType: applicationType ? applicationType : "Web",
    isSmoker: null,
  });

  useEffect(() => {
    if (!applicationId || !goalType) {
      window.location.replace(CONSUMER_PORTAL_URL + "404");
    }

    if (underwriting && !isEmpty(underwriting.carrierWiseLeads)) {
      const whereToRoute = getProcessStep(
        underwriting.resumeProcess,
        underwriting.goalType,
        underwriting.policyType,
        underwriting.productSelection
      );
      props.history.push(whereToRoute);
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    async function doSubmit() {
      try {
        const { isSmoker, applicationId, applicationType } = formData;
        if (isSmoker) {
          const splitpath = window.location.pathname.split("/");
          const request = {
            applicationId: applicationId,
            applicationType: applicationType,
            goalType: goalType,
            smoker: JSON.parse(isSmoker),
            resumeProcess: setProcessStep(splitpath[1], policyType, goalType),
          };

          const isAuthorized = getJwt() ? true : false;
          const apiEndPoint = API_URL_UNDERWRITING + "saveUnderWriting";
          const response = await commonApiCall(
            apiEndPoint,
            "post",
            request,
            UNDERWRITING_DETAILS,
            isAuthorized
          );
          if (response.status.code === 200) {
            const eventObject = {
              agent_id: response?.data?.agentDetail?.agentId,
              application_id: applicationId,
              param_name: "Smoker",
              param_value: response.data.smoker,
            };
            segmentTracking("application_set_param", eventObject);
            props.history.push(UnderWritingRoutes.CITIZENSHIP);
          } else {
            showErrorToast(response.status.message);
          }
        }
      } catch (err) {
        showErrorToast(t("validation_message.SOMETHING_WENT_WRONG"));
      }
    }
    doSubmit();
  }, [formData]);

  const { isSmoker } = formData;
  return (
    <React.Fragment>
      <div className="steps">
        <div className="title-header">
          <h2 className="page-title">{t("smoking_habit.do_you_smoke")}</h2>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-3 col-sm-6">
            <Animated
              animationIn="fadeInRight"
              animationOut="zoomOut"
              animationInDuration={800}
              animationOutDuration={800}
              isVisible={true}
            >
              <label className="boxmodal-radio">
                <input
                  type="radio"
                  name="isSmoker"
                  id="isSmoker"
                  value={true}
                  checked={isSmoker ? true : smoker ? true : false}
                  onChange={(e) => handleChange(e)}
                  onClick={(e) => handleChange(e)}
                />
                <div className="card-inner">
                  <div className="card-img">
                    <svg
                      width="69px"
                      height="48px"
                      viewBox="0 0 69 48"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>Yes</title>
                      <g
                        id="Page-1"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          id="1.1-Get-Started-option-4-Copy"
                          transform="translate(-4458.000000, -305.000000)"
                          fill="#2BA84A"
                          fillRule="nonzero"
                        >
                          <g
                            id="Smokeyes"
                            transform="translate(4458.000000, 305.000000)"
                          >
                            <path
                              d="M67.2655602,31.4149378 C67.4844116,31.4149378 67.6825444,31.5036448 67.8259643,31.6470648 C67.9693842,31.7904847 68.0580913,31.9886175 68.0580913,32.2074689 L68.0580913,46.5477178 C68.0580913,46.7665693 67.9693842,46.964702 67.8259643,47.108122 C67.6825444,47.2515419 67.4844116,47.340249 67.2655602,47.340249 L0.941908714,47.340249 C0.723057288,47.340249 0.524924508,47.2515419 0.381504584,47.108122 C0.238084661,46.964702 0.149377593,46.7665693 0.149377593,46.5477178 L0.149377593,32.2074689 C0.149377593,31.9886175 0.238084661,31.7904847 0.381504584,31.6470648 C0.524924508,31.5036448 0.723057288,31.4149378 0.941908714,31.4149378 L67.2655602,31.4149378 Z M16.2821577,33 L1.73443983,33 L1.73443983,45.7551867 L16.2821577,45.7551867 L16.2821577,33 Z M20.1861184,33 L17.8672199,33 L17.8672199,45.7551867 L32.9293776,45.7549087 L20.1861184,33 Z M66.473029,33 L60.8879668,33 L60.8879668,45.7551867 L66.473029,45.7551867 L66.473029,33 Z M59.3029046,33 L27.8233776,32.9999087 L40.5693776,45.7549087 L59.3029046,45.7551867 L59.3029046,33 Z M27.8138816,33 L20.1861184,33 L32.9413051,45.7551867 L40.5690683,45.7551867 L27.8138816,33 Z M43.9626556,0.941908714 C44.181507,0.941908714 44.3796398,1.03061578 44.5230597,1.1740357 C44.6664797,1.31745563 44.7551867,1.51558841 44.7551867,1.73443983 L44.7551867,6.31950207 L51.1327801,6.31950207 C51.3516315,6.31950207 51.5497643,6.40820914 51.6931842,6.55162907 C51.8366041,6.69504899 51.9253112,6.89318177 51.9253112,7.1120332 L51.9253112,17.0746888 L67.2655602,17.0746888 C67.4844116,17.0746888 67.6825444,17.1633959 67.8259643,17.3068158 C67.9693842,17.4502357 68.0580913,17.6483685 68.0580913,17.8672199 L68.0580913,25.0373444 C68.0580913,25.2561958 67.9693842,25.4543286 67.8259643,25.5977485 C67.6825444,25.7411685 67.4844116,25.8298755 67.2655602,25.8298755 C67.0467087,25.8298755 66.848576,25.7411685 66.705156,25.5977485 C66.5617361,25.4543286 66.473029,25.2561958 66.473029,25.0373444 L66.473029,18.659751 L51.1327801,18.659751 C50.9139287,18.659751 50.7157959,18.571044 50.572376,18.427624 C50.428956,18.2842041 50.340249,18.0860713 50.340249,17.8672199 L50.340249,7.90456432 L43.9626556,7.90456432 C43.7438042,7.90456432 43.5456714,7.81585725 43.4022515,7.67243732 C43.2588315,7.5290174 43.1701245,7.33088462 43.1701245,7.1120332 L43.1701245,2.52697095 L34,2.52697095 L34,13.4896266 L43.9626556,13.4896266 C44.181507,13.4896266 44.3796398,13.5783336 44.5230597,13.7217535 C44.6664797,13.8651735 44.7551867,14.0633063 44.7551867,14.2821577 L44.7551867,24.2448133 L60.0954357,24.2448133 C60.3142871,24.2448133 60.5124199,24.3335203 60.6558398,24.4769403 C60.7992597,24.6203602 60.8879668,24.818493 60.8879668,25.0373444 C60.8879668,25.2561958 60.7992597,25.4543286 60.6558398,25.5977485 C60.5124199,25.7411685 60.3142871,25.8298755 60.0954357,25.8298755 L43.9626556,25.8298755 C43.7438042,25.8298755 43.5456714,25.7411685 43.4022515,25.5977485 C43.2588315,25.4543286 43.1701245,25.2561958 43.1701245,25.0373444 L43.1701245,15.0746888 L33.2074689,15.0746888 C32.9886175,15.0746888 32.7904847,14.9859817 32.6470648,14.8425618 C32.5036448,14.6991419 32.4149378,14.5010091 32.4149378,14.2821577 L32.4149378,1.73443983 C32.4149378,1.51558841 32.5036448,1.31745563 32.6470648,1.1740357 C32.7904847,1.03061578 32.9886175,0.941908714 33.2074689,0.941908714 L43.9626556,0.941908714 Z"
                              id="Combined-Shape"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <h2 className="page-title mb-0">{t("smoking_habit.yes")}</h2>
                </div>
              </label>
            </Animated>
          </div>
          <div className="col-lg-3 col-sm-6">
            <Animated
              animationIn="fadeInRight"
              animationOut="zoomOut"
              animationInDuration={800}
              animationOutDuration={800}
              isVisible={true}
            >
              <label className="boxmodal-radio">
                <input
                  type="radio"
                  name="isSmoker"
                  id="isSmoker"
                  value={false}
                  checked={
                    isSmoker === false ? true : smoker === false ? true : false
                  }
                  onChange={(e) => handleChange(e)}
                  onClick={(e) => handleChange(e)}
                />
                <div className="card-inner">
                  <div className="card-img">
                    <svg
                      width="106px"
                      height="106px"
                      viewBox="0 0 106 106"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>No</title>
                      <g
                        id="Page-1"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          id="1.1-Get-Started-option-4-Copy"
                          transform="translate(-4756.000000, -276.000000)"
                          fill="#2BA84A"
                          fillRule="nonzero"
                        >
                          <path
                            d="M4819.29045,277.239308 C4829.31767,279.235026 4838.76609,284.138857 4846.31237,291.687415 C4856.61376,301.991912 4861.76445,315.495956 4861.76445,329 C4861.76445,342.504044 4856.61376,356.008088 4846.31237,366.312585 C4838.76609,373.861143 4829.31767,378.764974 4819.29045,380.760692 C4809.26323,382.756411 4798.65721,381.844018 4788.79572,377.76013 C4778.93424,373.676241 4770.78845,366.823039 4765.10804,358.322394 C4759.42762,349.821749 4756.21258,339.673662 4756.21258,329 C4756.21258,318.326338 4759.42762,308.178251 4765.10804,299.677606 C4770.78845,291.176961 4778.93424,284.323759 4788.79572,280.23987 C4798.65721,276.155982 4809.26323,275.243589 4819.29045,277.239308 Z M4809.00188,277.791203 C4795.90127,277.791203 4782.80082,282.789709 4772.80559,292.785278 C4762.81036,302.780847 4757.81275,315.881461 4757.81275,328.982075 C4757.81275,342.082689 4762.81036,355.183302 4772.80559,365.178871 C4782.79975,375.173369 4795.89847,380.171432 4808.99768,380.175188 C4822.0996,380.17894 4835.20197,375.186312 4845.19886,365.199582 C4854.80588,355.598395 4860.20346,342.573086 4860.20346,328.991037 C4860.20346,315.408988 4854.80588,302.38368 4845.19901,292.782637 C4835.20328,282.787927 4822.10249,277.791203 4809.00188,277.791203 Z M4774.86122,299.167461 C4775.08278,299.157528 4775.29837,299.240889 4775.45302,299.394703 L4838.56901,362.636171 C4838.72571,362.792752 4838.80972,363.007769 4838.80135,363.229108 C4838.79166,363.450446 4838.6904,363.657902 4838.52015,363.802306 C4830.2859,370.810779 4819.81635,374.642769 4808.99625,374.606469 C4800.09053,374.639519 4791.58417,372.074102 4784.37074,367.47905 C4777.15735,362.884025 4771.23686,356.259388 4767.50281,348.17428 C4763.76874,340.089152 4762.56423,331.28645 4763.74322,322.815484 C4764.92221,314.344519 4768.4847,306.205291 4774.28645,299.445024 C4774.42973,299.277138 4774.63654,299.176609 4774.86122,299.167461 Z M4774.85155,301.186068 C4767.60771,310.131145 4764.39566,321.096113 4765.07239,331.815576 C4765.72685,342.182111 4770.01823,352.319042 4777.81718,360.177446 C4785.6898,368.022522 4795.85673,372.335576 4806.25403,372.990318 C4817.0044,373.667293 4828.00105,370.433283 4836.95823,363.14435 L4816.15413,342.340249 L4774.94191,342.340249 C4774.72306,342.340249 4774.52492,342.251542 4774.3815,342.108122 C4774.23808,341.964702 4774.14938,341.766569 4774.14938,341.547718 L4774.14938,327.207469 C4774.14938,326.988617 4774.23808,326.790485 4774.3815,326.647065 C4774.52492,326.503645 4774.72306,326.414938 4774.94191,326.414938 L4800.2396,326.414938 L4774.85155,301.186068 Z M4810.82259,283.513319 C4821.90114,283.956713 4832.81943,288.404455 4841.23609,296.756838 C4849.58431,305.189035 4854.01923,316.111784 4854.45004,327.190242 C4854.88085,338.2687 4851.30756,349.502867 4843.64185,358.554976 C4843.50234,358.718436 4843.30262,358.818042 4843.08865,358.831489 C4842.88429,358.828153 4842.6889,358.746052 4842.54628,358.604594 L4779.39514,295.453456 C4779.23844,295.296875 4779.15442,295.081857 4779.1628,294.860519 C4779.17249,294.63918 4779.27375,294.431725 4779.44127,294.289642 C4788.50522,286.63088 4799.74404,283.069925 4810.82259,283.513319 Z M4781.05015,294.955968 L4812.60192,326.414938 L4841.26556,326.414938 C4841.48441,326.414938 4841.68254,326.503645 4841.82596,326.647065 C4841.96938,326.790485 4842.05809,326.988617 4842.05809,327.207469 L4842.05809,341.547718 C4842.05809,341.766569 4841.96938,341.964702 4841.82596,342.108122 C4841.68254,342.251542 4841.48441,342.340249 4841.26556,342.340249 L4828.51364,342.340249 L4843.13966,356.858092 C4850.54208,347.928026 4853.85013,336.903119 4853.20357,326.115226 C4852.57788,315.675546 4848.24875,305.457828 4840.34284,297.575336 C4832.43693,289.692843 4822.20641,285.394044 4811.76492,284.799324 C4800.97439,284.184724 4789.95855,287.525982 4781.05015,294.955968 Z M4790.28216,328 L4775.73444,328 L4775.73444,340.755187 L4790.28216,340.755187 L4790.28216,328 Z M4801.81388,328 L4791.86722,328 L4791.86722,340.755187 L4814.56907,340.755187 L4801.81388,328 Z M4840.47303,328 L4834.88797,328 L4834.88797,340.755187 L4840.47303,340.755187 L4840.47303,328 Z M4833.3029,328 L4814.18612,328 L4826.94131,340.755187 L4833.3029,340.755187 L4833.3029,328 Z M4817.96266,295.941909 C4818.18151,295.941909 4818.37964,296.030616 4818.52306,296.174036 C4818.66648,296.317456 4818.75519,296.515588 4818.75519,296.73444 L4818.75519,301.319502 L4825.13278,301.319502 C4825.35163,301.319502 4825.54976,301.408209 4825.69318,301.551629 C4825.8366,301.695049 4825.92531,301.893182 4825.92531,302.112033 L4825.92531,312.074689 L4841.26556,312.074689 C4841.48441,312.074689 4841.68254,312.163396 4841.82596,312.306816 C4841.96938,312.450236 4842.05809,312.648368 4842.05809,312.86722 L4842.05809,320.037344 C4842.05809,320.256196 4841.96938,320.454329 4841.82596,320.597749 C4841.68254,320.741168 4841.48441,320.829876 4841.26556,320.829876 C4841.04671,320.829876 4840.84858,320.741168 4840.70516,320.597749 C4840.56174,320.454329 4840.47303,320.256196 4840.47303,320.037344 L4840.47303,313.659751 L4825.13278,313.659751 C4824.91393,313.659751 4824.7158,313.571044 4824.57238,313.427624 C4824.42896,313.284204 4824.34025,313.086071 4824.34025,312.86722 L4824.34025,302.904564 L4817.96266,302.904564 C4817.7438,302.904564 4817.54567,302.815857 4817.40225,302.672437 C4817.25883,302.529017 4817.17012,302.330885 4817.17012,302.112033 L4817.17012,297.526971 L4808,297.526971 L4808,308.489627 L4817.96266,308.489627 C4818.18151,308.489627 4818.37964,308.578334 4818.52306,308.721754 C4818.66648,308.865173 4818.75519,309.063306 4818.75519,309.282158 L4818.75519,319.244813 L4834.09544,319.244813 C4834.31429,319.244813 4834.51242,319.33352 4834.65584,319.47694 C4834.79926,319.62036 4834.88797,319.818493 4834.88797,320.037344 C4834.88797,320.256196 4834.79926,320.454329 4834.65584,320.597749 C4834.51242,320.741168 4834.31429,320.829876 4834.09544,320.829876 L4817.96266,320.829876 C4817.7438,320.829876 4817.54567,320.741168 4817.40225,320.597749 C4817.25883,320.454329 4817.17012,320.256196 4817.17012,320.037344 L4817.17012,310.074689 L4807.20747,310.074689 C4806.98862,310.074689 4806.79048,309.985982 4806.64706,309.842562 C4806.50364,309.699142 4806.41494,309.501009 4806.41494,309.282158 L4806.41494,296.73444 C4806.41494,296.515588 4806.50364,296.317456 4806.64706,296.174036 C4806.79048,296.030616 4806.98862,295.941909 4807.20747,295.941909 L4817.96266,295.941909 Z"
                            id="Smokeno"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <h2 className="page-title mb-0">{t("smoking_habit.no")}</h2>
                </div>
              </label>
            </Animated>
          </div>
          <div className="col-12 text-center mt-3">
            <Link
              to={UnderWritingRoutes.YOUR_HEALTH}
              className="btn btn-link"
              title="Back"
            >
              {t("back")}
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  underwriting: state.underwriting.underwriting,
});

export default connect(mapStateToProps, { commonApiCall })(
  withRouter(SmokingHabit)
);
